"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  BOTBarcode: () => BOTBarcode,
  EMVCoQR: () => EMVCoQR,
  checksum: () => checksum,
  decode: () => decode,
  encode: () => encode,
  generate: () => generate_exports,
  get: () => get,
  parse: () => parse,
  parseBarcode: () => parseBarcode,
  tag: () => tag,
  validate: () => validate_exports,
  withCrcTag: () => withCrcTag
});
module.exports = __toCommonJS(index_exports);

// src/utils/checksum.ts
var TABLE = [
  0,
  4129,
  8258,
  12387,
  16516,
  20645,
  24774,
  28903,
  33032,
  37161,
  41290,
  45419,
  49548,
  53677,
  57806,
  61935,
  4657,
  528,
  12915,
  8786,
  21173,
  17044,
  29431,
  25302,
  37689,
  33560,
  45947,
  41818,
  54205,
  50076,
  62463,
  58334,
  9314,
  13379,
  1056,
  5121,
  25830,
  29895,
  17572,
  21637,
  42346,
  46411,
  34088,
  38153,
  58862,
  62927,
  50604,
  54669,
  13907,
  9842,
  5649,
  1584,
  30423,
  26358,
  22165,
  18100,
  46939,
  42874,
  38681,
  34616,
  63455,
  59390,
  55197,
  51132,
  18628,
  22757,
  26758,
  30887,
  2112,
  6241,
  10242,
  14371,
  51660,
  55789,
  59790,
  63919,
  35144,
  39273,
  43274,
  47403,
  23285,
  19156,
  31415,
  27286,
  6769,
  2640,
  14899,
  10770,
  56317,
  52188,
  64447,
  60318,
  39801,
  35672,
  47931,
  43802,
  27814,
  31879,
  19684,
  23749,
  11298,
  15363,
  3168,
  7233,
  60846,
  64911,
  52716,
  56781,
  44330,
  48395,
  36200,
  40265,
  32407,
  28342,
  24277,
  20212,
  15891,
  11826,
  7761,
  3696,
  65439,
  61374,
  57309,
  53244,
  48923,
  44858,
  40793,
  36728,
  37256,
  33193,
  45514,
  41451,
  53516,
  49453,
  61774,
  57711,
  4224,
  161,
  12482,
  8419,
  20484,
  16421,
  28742,
  24679,
  33721,
  37784,
  41979,
  46042,
  49981,
  54044,
  58239,
  62302,
  689,
  4752,
  8947,
  13010,
  16949,
  21012,
  25207,
  29270,
  46570,
  42443,
  38312,
  34185,
  62830,
  58703,
  54572,
  50445,
  13538,
  9411,
  5280,
  1153,
  29798,
  25671,
  21540,
  17413,
  42971,
  47098,
  34713,
  38840,
  59231,
  63358,
  50973,
  55100,
  9939,
  14066,
  1681,
  5808,
  26199,
  30326,
  17941,
  22068,
  55628,
  51565,
  63758,
  59695,
  39368,
  35305,
  47498,
  43435,
  22596,
  18533,
  30726,
  26663,
  6336,
  2273,
  14466,
  10403,
  52093,
  56156,
  60223,
  64286,
  35833,
  39896,
  43963,
  48026,
  19061,
  23124,
  27191,
  31254,
  2801,
  6864,
  10931,
  14994,
  64814,
  60687,
  56684,
  52557,
  48554,
  44427,
  40424,
  36297,
  31782,
  27655,
  23652,
  19525,
  15522,
  11395,
  7392,
  3265,
  61215,
  65342,
  53085,
  57212,
  44955,
  49082,
  36825,
  40952,
  28183,
  32310,
  20053,
  24180,
  11923,
  16050,
  3793,
  7920
];
function crc16xmodem(data, crc = 0) {
  for (const i of data) {
    const b = i.charCodeAt(0);
    const n = (b ^ crc >> 8) & 255;
    crc = TABLE[n] ^ crc << 8;
  }
  return (crc ^ 0) & 65535;
}

// src/lib/tlv.ts
function decode(payload) {
  const tags = [];
  let idx = 0;
  while (idx < payload.length) {
    const data = payload.substring(idx);
    const id = data.substring(0, 2);
    const length = parseInt(data.substring(2, 4));
    const value = data.substring(4, 4 + length);
    tags.push({ id, length, value });
    idx += length + 4;
  }
  return tags;
}
function encode(tags) {
  let payload = "";
  for (const tag2 of tags) {
    payload += tag2.id;
    payload += ("00" + tag2.length).slice(-2);
    if (tag2.subTags) {
      payload += encode(tag2.subTags);
      continue;
    }
    payload += tag2.value;
  }
  return payload;
}
function checksum(payload, upperCase = true) {
  let sum = crc16xmodem(payload, 65535).toString(16);
  sum = upperCase ? sum.toUpperCase() : sum.toLowerCase();
  sum = ("0000" + sum).slice(-4);
  return sum;
}
function withCrcTag(payload, crcTagId, upperCase = true) {
  payload += ("00" + crcTagId).slice(-2);
  payload += "04";
  payload += checksum(payload, upperCase);
  return payload;
}
function get(tlvTags, tagId, subTagId) {
  const tag2 = tlvTags.find((t) => t.id == tagId);
  if (subTagId) {
    return tag2?.subTags?.find((s) => s.id == subTagId);
  }
  return tag2;
}
function tag(tagId, value) {
  return {
    id: tagId,
    length: value.length,
    value
  };
}

// src/lib/EMVCoQR.ts
var EMVCoQR = class {
  constructor(payload, tags) {
    __publicField(this, "payload");
    __publicField(this, "tags");
    this.payload = payload;
    this.tags = tags;
  }
  getTag(tagId, subTagId) {
    return get(this.tags, tagId, subTagId);
  }
  getTagValue(tagId, subTagId) {
    return this.getTag(tagId, subTagId)?.value;
  }
  getTags() {
    return this.tags;
  }
  /* c8 ignore next 3 */
  getPayload() {
    return this.payload;
  }
  validate(crcTagId) {
    const tags = [...this.tags].filter((f) => f.id != crcTagId);
    const expected = withCrcTag(encode(tags), crcTagId);
    return this.payload === expected;
  }
};

// src/generate/promptpay/BillPayment.ts
function billPayment({
  billerId,
  amount,
  ref1,
  ref2,
  ref3
}) {
  const tag30 = [
    tag("00", "A000000677010112"),
    tag("01", billerId),
    tag("02", ref1)
  ];
  if (ref2) {
    tag30.push(tag("03", ref2));
  }
  const payload = [
    tag("00", "01"),
    tag("01", !amount ? "11" : "12"),
    tag("30", encode(tag30)),
    tag("53", "764"),
    tag("58", "TH")
  ];
  if (amount) {
    payload.push(tag("54", Number(amount).toFixed(2)));
  }
  if (ref3) {
    payload.push(tag("62", encode([tag("07", ref3)])));
  }
  return withCrcTag(encode(payload), "63");
}

// src/lib/BOTBarcode.ts
var BOTBarcode = class _BOTBarcode {
  constructor(billerId, ref1, ref2 = null, amount = null) {
    __publicField(this, "billerId");
    __publicField(this, "ref1");
    __publicField(this, "ref2");
    __publicField(this, "amount");
    this.billerId = billerId;
    this.ref1 = ref1;
    this.ref2 = ref2;
    this.amount = amount;
  }
  static fromString(payload) {
    if (!payload.startsWith("|")) {
      return null;
    }
    const data = payload.slice(1).split("\r", 4);
    if (data.length != 4) {
      return null;
    }
    const [billerId, ref1, ref2, amount] = data;
    return new _BOTBarcode(
      billerId,
      ref1,
      ref2.length > 0 ? ref2 : null,
      amount != "0" ? Number((parseInt(amount) / 100).toFixed(2)) : null
    );
  }
  toString() {
    const { billerId, ref1, ref2, amount } = this;
    const amountStr = amount ? String(Number(amount.toFixed(2)) * 100) : "0";
    return `|${billerId}\r${ref1}\r${ref2 ?? ""}\r${amountStr}`;
  }
  /**
   * Converts BOT Barcode to PromptPay QR Tag 30 (Bill Payment)
   *
   * This method works for some biller, depends on destination bank
   *
   * @returns QR Code payload
   */
  toQrTag30() {
    const { billerId, ref1, ref2, amount } = this;
    return billPayment({
      billerId,
      ref1,
      ref2: ref2 ?? void 0,
      amount: amount ?? void 0
    });
  }
};

// src/lib/parser.ts
function parse(payload, strict = false, subTags = true) {
  if (!payload.match(/^\d{4}.+/)) {
    return null;
  }
  if (strict) {
    const expected = payload.slice(-4).toUpperCase();
    const calculated = checksum(payload.slice(0, -4));
    if (expected != calculated) return null;
  }
  const tags = decode(payload);
  if (tags.length == 0) {
    return null;
  }
  if (subTags) {
    for (const tag2 of tags) {
      if (typeof tag2.value !== "string" || !tag2.value.match(/^\d{4}.+/)) {
        continue;
      }
      const sub = decode(tag2.value);
      if (sub.every((val) => val.length > 0 && val.length === val.value.length)) {
        tag2.subTags = sub;
      }
    }
  }
  return new EMVCoQR(payload, tags);
}
function parseBarcode(payload) {
  return BOTBarcode.fromString(payload);
}

// src/generate/index.ts
var generate_exports = {};
__export(generate_exports, {
  ProxyType: () => ProxyType,
  anyId: () => anyId,
  billPayment: () => billPayment,
  botBarcode: () => botBarcode,
  slipVerify: () => slipVerify,
  trueMoney: () => trueMoney,
  trueMoneySlipVerify: () => trueMoneySlipVerify
});

// src/generate/promptpay/AnyID.ts
var ProxyType = /* @__PURE__ */ ((ProxyType2) => {
  ProxyType2["MSISDN"] = "01";
  ProxyType2["NATID"] = "02";
  ProxyType2["EWALLETID"] = "03";
  ProxyType2["BANKACC"] = "04";
  return ProxyType2;
})(ProxyType || {});
function anyId({ type, target, amount }) {
  if (type == "MSISDN") {
    target = ("0000000000000" + target.replace(/^0/, "66")).slice(-13);
  }
  const tag29 = encode([
    tag("00", "A000000677010111"),
    tag(ProxyType[type], target)
  ]);
  const payload = [
    tag("00", "01"),
    tag("01", !amount ? "11" : "12"),
    tag("29", tag29),
    tag("53", "764"),
    tag("58", "TH")
  ];
  if (amount) {
    payload.push(tag("54", Number(amount).toFixed(2)));
  }
  return withCrcTag(encode(payload), "63");
}

// src/utils/encoder.ts
function encodeTag81(message) {
  return message.split("").map((c) => c.charCodeAt(0).toString(16).padStart(4, "0")).join("").toUpperCase();
}

// src/generate/TrueMoney.ts
function trueMoney({ mobileNo, amount, message }) {
  const tag29 = encode([
    tag("00", "A000000677010111"),
    tag("03", `14000${mobileNo}`)
  ]);
  const payload = [
    tag("00", "01"),
    tag("01", !amount ? "11" : "12"),
    tag("29", tag29),
    tag("53", "764"),
    tag("58", "TH")
  ];
  if (amount) {
    payload.push(tag("54", Number(amount).toFixed(2)));
  }
  if (message) {
    payload.push(tag("81", encodeTag81(message)));
  }
  return withCrcTag(encode(payload), "63");
}

// src/generate/TrueMoneySlipVerify.ts
function trueMoneySlipVerify({
  eventType,
  transactionId,
  date
}) {
  const payload = [
    tag(
      "00",
      encode([
        tag("00", "01"),
        tag("01", "01"),
        tag("02", eventType),
        tag("03", transactionId),
        tag("04", date)
      ])
    )
  ];
  return withCrcTag(encode(payload), "91", false);
}

// src/generate/SlipVerify.ts
function slipVerify({ sendingBank, transRef }) {
  const payload = [
    tag(
      "00",
      encode([
        tag("00", "000001"),
        tag("01", sendingBank),
        tag("02", transRef)
      ])
    ),
    tag("51", "TH")
  ];
  return withCrcTag(encode(payload), "91");
}

// src/generate/BOTBarcode.ts
function botBarcode({ billerId, ref1, ref2, amount }) {
  return new BOTBarcode(billerId, ref1, ref2, amount).toString();
}

// src/validate/index.ts
var validate_exports = {};
__export(validate_exports, {
  bcelOneProof: () => bcelOneProof,
  slipVerify: () => slipVerify2,
  trueMoneySlipVerify: () => trueMoneySlipVerify2
});

// src/validate/SlipVerify.ts
function slipVerify2(payload, crcAutoFix = true) {
  if (crcAutoFix) {
    const idx = payload.lastIndexOf("9104");
    if (idx != -1) {
      const crc = payload.substring(idx + 4);
      if (crc.length > 0 && crc.length < 4) {
        payload = payload.substring(0, idx + 4) + crc.padStart(4, "0");
      }
    }
  }
  const ppqr = parse(payload, true);
  const apiType = ppqr?.getTagValue("00", "00");
  const sendingBank = ppqr?.getTagValue("00", "01");
  const transRef = ppqr?.getTagValue("00", "02");
  if (apiType !== "000001" || !sendingBank || !transRef) {
    return null;
  }
  return {
    sendingBank,
    transRef
  };
}

// src/validate/TrueMoneySlipVerify.ts
function trueMoneySlipVerify2(payload) {
  const ppqr = parse(payload, true);
  const eventType = ppqr?.getTagValue("00", "02");
  const transactionId = ppqr?.getTagValue("00", "03");
  const date = ppqr?.getTagValue("00", "04");
  if (ppqr?.getTagValue("00", "00") !== "01" && ppqr?.getTagValue("00", "01") !== "01") {
    return null;
  }
  return {
    eventType,
    transactionId,
    date
  };
}

// src/validate/BCELOneProof.ts
function bcelOneProof(payload) {
  const ppqr = parse(payload, true);
  const type = ppqr?.getTagValue("33", "02");
  const ticket = ppqr?.getTagValue("33", "03");
  const fccref = ppqr?.getTagValue("33", "04");
  if (ppqr?.getTagValue("00") !== "01" && ppqr?.getTagValue("01") !== "11" && ppqr?.getTagValue("33", "00") !== "BCEL" && ppqr?.getTagValue("33", "00") !== "ONEPROOF") {
    return null;
  }
  return {
    type,
    ticket,
    fccref
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BOTBarcode,
  EMVCoQR,
  checksum,
  decode,
  encode,
  generate,
  get,
  parse,
  parseBarcode,
  tag,
  validate,
  withCrcTag
});
